<template>
  <b-button variant="secondary" @click="click" :disabled="disabled">
    <slot v-if="hasDefaultSlot()"></slot>
    <template v-else>
      {{text}}
    </template>
  </b-button>
</template>

<script>
  import i18n from "../../../shared/i18n";

  export default {
    name: "CancelButton",
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      text: {
        type: String,
        default: i18n.t('Cancel')
      }
    },
    methods: {
      click($e) {
        this.$emit('click', $e)
      },
      hasDefaultSlot() {
        return !!this.$slots.default;
      }
    }
  }
</script>

<style scoped>

</style>
